import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { ShoppingCart, Plus, Minus, X, Truck, MapPin, ShoppingBag } from "lucide-react";

const MerchPage = () => {
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);

  const products = [
    // T-SHIRTS - $25
    {
      id: "tshirt-white-sports",
      name: "Top Notch Sports Tee",
      category: "T-Shirt",
      color: "White",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/vm84uj83_IMG_7688.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "tshirt-black-sports",
      name: "Top Notch Sports Tee",
      category: "T-Shirt",
      color: "Black",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/1t7a1gmd_IMG_7689.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "tshirt-gray-sports",
      name: "Top Notch Sports Tee",
      category: "T-Shirt",
      color: "Gray",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/xzpqkwrm_IMG_7693.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    // LONG SLEEVES - $25
    {
      id: "longsleeve-white-sports",
      name: "Top Notch Sports Long Sleeve",
      category: "Long Sleeve",
      color: "White",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/6c64xttq_IMG_7690.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "longsleeve-black-sports",
      name: "Top Notch Sports Long Sleeve",
      category: "Long Sleeve",
      color: "Black",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/ts9phorw_IMG_7691.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "longsleeve-gray-sports",
      name: "Top Notch Sports Long Sleeve",
      category: "Long Sleeve",
      color: "Gray",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/kkm2bude_IMG_7692.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    // SWEATSHIRTS (Crewneck) - $25
    {
      id: "sweatshirt-white-sports",
      name: "Top Notch Sports Sweatshirt",
      category: "Sweatshirt",
      color: "White",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/ucp4l3vr_IMG_7697.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "sweatshirt-black-sports",
      name: "Top Notch Sports Sweatshirt",
      category: "Sweatshirt",
      color: "Black",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/u582ua5v_IMG_7698.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "sweatshirt-gray-sports",
      name: "Top Notch Sports Sweatshirt",
      category: "Sweatshirt",
      color: "Gray",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/6rburs0p_IMG_7699.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    // HEALTH & FITNESS T-SHIRTS - $25
    {
      id: "tshirt-white-hf",
      name: "Top Notch Health & Fitness Tee",
      category: "T-Shirt",
      color: "White",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/u8i5kaza_IMG_7700.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "tshirt-black-hf",
      name: "Top Notch Health & Fitness Tee",
      category: "T-Shirt",
      color: "Black",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/b96e35ue_IMG_7701.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "tshirt-gray-hf",
      name: "Top Notch Health & Fitness Tee",
      category: "T-Shirt",
      color: "Gray",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/js14kkgj_IMG_7702.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    // HEALTH & FITNESS SWEATSHIRTS - $25
    {
      id: "sweatshirt-white-hf",
      name: "Top Notch Health & Fitness Sweatshirt",
      category: "Sweatshirt",
      color: "White",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/hkkwi4r1_IMG_7708.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "sweatshirt-gray-hf",
      name: "Top Notch Health & Fitness Sweatshirt",
      category: "Sweatshirt",
      color: "Gray",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/vfrpl98n_IMG_7706.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "sweatshirt-black-hf",
      name: "Top Notch Health & Fitness Sweatshirt",
      category: "Sweatshirt",
      color: "Black",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/49f1722d_IMG_7707.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    // HEALTH & FITNESS HOODIES - $35
    {
      id: "hoodie-white-hf",
      name: "Top Notch Health & Fitness Hoodie",
      category: "Hoodie",
      color: "White",
      price: 35,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/24f7zogf_IMG_7703.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "hoodie-black-hf",
      name: "Top Notch Health & Fitness Hoodie",
      category: "Hoodie",
      color: "Black",
      price: 35,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/ky5ltetz_IMG_7704.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "hoodie-gray-hf",
      name: "Top Notch Health & Fitness Hoodie",
      category: "Hoodie",
      color: "Gray",
      price: 35,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/m2ngi2y5_IMG_7705.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    // HOODIES - $35
    {
      id: "hoodie-white-sports",
      name: "Top Notch Sports Hoodie",
      category: "Hoodie",
      color: "White",
      price: 35,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/l023y6g0_IMG_7694.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "hoodie-black-sports",
      name: "Top Notch Sports Hoodie",
      category: "Hoodie",
      color: "Black",
      price: 35,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/5afprfz7_IMG_7695.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    },
    {
      id: "hoodie-gray-sports",
      name: "Top Notch Sports Hoodie",
      category: "Hoodie",
      color: "Gray",
      price: 35,
      image: "https://customer-assets.emergentagent.com/job_6b5e3bef-198e-4658-8305-ef4fd544fb4d/artifacts/iahue3xf_IMG_7696.JPG",
      sizes: ["S", "M", "L", "XL", "2XL"]
    }
  ];

  const addToCart = (product, size) => {
    const existingItem = cart.find(item => item.id === product.id && item.size === size);
    
    if (existingItem) {
      setCart(cart.map(item => 
        item.id === product.id && item.size === size 
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([...cart, { ...product, size, quantity: 1, cartId: `${product.id}-${size}-${Date.now()}` }]);
    }
    
    toast.success(`${product.name} (${size}) added to cart!`);
  };

  const removeFromCart = (cartId) => {
    setCart(cart.filter(item => item.cartId !== cartId));
  };

  const updateQuantity = (cartId, delta) => {
    setCart(cart.map(item => {
      if (item.cartId === cartId) {
        const newQuantity = item.quantity + delta;
        return newQuantity > 0 ? { ...item, quantity: newQuantity } : item;
      }
      return item;
    }).filter(item => item.quantity > 0));
  };

  const cartTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleCheckout = () => {
    if (cart.length === 0) {
      toast.error("Your cart is empty!");
      return;
    }
    
    // Create order message for contact
    const orderDetails = cart.map(item => 
      `${item.name} (${item.size}) x${item.quantity} - $${item.price * item.quantity}`
    ).join('\n');
    
    const message = `MERCH ORDER:\n\n${orderDetails}\n\nTotal: $${cartTotal}\n\nPickup/Local Drop-off Only`;
    
    // Open email with order
    const mailtoLink = `mailto:topnotchhf@gmail.com?subject=Top Notch Merch Order&body=${encodeURIComponent(message)}`;
    window.location.href = mailtoLink;
    
    toast.success("Opening email to complete your order!");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="merch-page">
      {/* Hero */}
      <section className="py-16 bg-gradient-to-b from-[#111111] to-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-display text-4xl md:text-6xl text-white mb-4">
            TOP NOTCH <span className="text-[#E10600]">MERCH</span>
          </h1>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Rep the brand. Look elite.
          </p>
        </div>
      </section>

      {/* Notice Banner */}
      <div className="bg-[#E10600]/10 border-y border-[#E10600]/30 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center gap-3 text-center">
            <MapPin className="w-5 h-5 text-[#E10600] flex-shrink-0" />
            <p className="text-white text-sm md:text-base">
              <span className="font-bold text-[#E10600]">Pickup or Local Drop-off Only</span> — Shipping is unavailable
            </p>
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Price Guide */}
          <div className="flex flex-wrap justify-center gap-6 mb-12">
            <div className="bg-[#111111] border border-[#2A2A2A] rounded-lg px-6 py-3">
              <span className="text-gray-400">T-Shirts & Sweatshirts:</span>
              <span className="text-[#E10600] font-bold ml-2">$25</span>
            </div>
            <div className="bg-[#111111] border border-[#2A2A2A] rounded-lg px-6 py-3">
              <span className="text-gray-400">Hoodies:</span>
              <span className="text-[#E10600] font-bold ml-2">$35</span>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="products-grid">
            {products.map((product) => (
              <ProductCard 
                key={product.id} 
                product={product} 
                onAddToCart={addToCart}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Floating Cart Button */}
      <button
        onClick={() => setShowCart(true)}
        className="fixed bottom-6 right-6 bg-[#E10600] text-white p-4 rounded-full shadow-lg hover:bg-[#B80500] transition-all z-40"
        data-testid="cart-button"
      >
        <ShoppingCart className="w-6 h-6" />
        {cartCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-white text-[#0A0A0A] text-xs font-bold w-6 h-6 rounded-full flex items-center justify-center">
            {cartCount}
          </span>
        )}
      </button>

      {/* Cart Sidebar */}
      {showCart && (
        <div className="fixed inset-0 z-50" data-testid="cart-sidebar">
          {/* Overlay */}
          <div 
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
            onClick={() => setShowCart(false)}
          />
          
          {/* Cart Panel */}
          <div className="absolute right-0 top-0 h-full w-full max-w-md bg-[#111111] border-l border-[#2A2A2A] shadow-2xl">
            <div className="flex flex-col h-full">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#2A2A2A]">
                <h2 className="font-display text-2xl text-white flex items-center gap-2">
                  <ShoppingBag className="w-6 h-6 text-[#E10600]" />
                  YOUR CART
                </h2>
                <button 
                  onClick={() => setShowCart(false)}
                  className="text-gray-400 hover:text-white"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Cart Items */}
              <div className="flex-1 overflow-y-auto p-6">
                {cart.length === 0 ? (
                  <div className="text-center py-12">
                    <ShoppingCart className="w-16 h-16 text-gray-600 mx-auto mb-4" />
                    <p className="text-gray-400">Your cart is empty</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {cart.map((item) => (
                      <div key={item.cartId} className="bg-[#1a1a1a] rounded-lg p-4 border border-[#2A2A2A]">
                        <div className="flex gap-4">
                          <div className="w-16 h-16 bg-[#2A2A2A] rounded flex items-center justify-center flex-shrink-0">
                            {item.image ? (
                              <img src={item.image} alt={item.name} className="w-full h-full object-cover rounded" />
                            ) : (
                              <ShoppingBag className="w-8 h-8 text-gray-500" />
                            )}
                          </div>
                          <div className="flex-1">
                            <h4 className="text-white font-medium text-sm">{item.name}</h4>
                            <p className="text-gray-400 text-xs">Size: {item.size}</p>
                            <p className="text-[#E10600] font-bold">${item.price}</p>
                          </div>
                          <button 
                            onClick={() => removeFromCart(item.cartId)}
                            className="text-gray-500 hover:text-red-500"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                        <div className="flex items-center justify-end gap-3 mt-3">
                          <button 
                            onClick={() => updateQuantity(item.cartId, -1)}
                            className="w-8 h-8 rounded bg-[#2A2A2A] flex items-center justify-center text-white hover:bg-[#3A3A3A]"
                          >
                            <Minus className="w-4 h-4" />
                          </button>
                          <span className="text-white font-medium w-8 text-center">{item.quantity}</span>
                          <button 
                            onClick={() => updateQuantity(item.cartId, 1)}
                            className="w-8 h-8 rounded bg-[#2A2A2A] flex items-center justify-center text-white hover:bg-[#3A3A3A]"
                          >
                            <Plus className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Footer */}
              {cart.length > 0 && (
                <div className="p-6 border-t border-[#2A2A2A]">
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-gray-400">Total</span>
                    <span className="text-white font-display text-2xl">${cartTotal}</span>
                  </div>
                  
                  <div className="bg-[#1a1a1a] rounded-lg p-3 mb-4 border border-[#2A2A2A]">
                    <div className="flex items-center gap-2 text-gray-400 text-sm">
                      <MapPin className="w-4 h-4 text-[#E10600]" />
                      <span>Pickup or Local Drop-off Only</span>
                    </div>
                  </div>

                  <Button 
                    onClick={handleCheckout}
                    className="w-full cta-btn-primary"
                    data-testid="checkout-button"
                  >
                    <ShoppingBag className="w-5 h-5 mr-2" />
                    PLACE ORDER
                  </Button>
                  
                  <p className="text-gray-500 text-xs text-center mt-3">
                    Orders will be sent via email for confirmation
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Product Card Component
const ProductCard = ({ product, onAddToCart }) => {
  const [selectedSize, setSelectedSize] = useState(null);

  const handleAddToCart = () => {
    if (!selectedSize) {
      toast.error("Please select a size");
      return;
    }
    onAddToCart(product, selectedSize);
    setSelectedSize(null);
  };

  return (
    <Card className="bg-[#111111] border-[#2A2A2A] hover:border-[#E10600]/50 transition-all overflow-hidden" data-testid={`product-${product.id}`}>
      {/* Product Image */}
      <div className="aspect-square bg-[#1a1a1a] flex items-center justify-center relative">
        {product.image ? (
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
        ) : (
          <div className="text-center p-4">
            <ShoppingBag className="w-16 h-16 text-[#E10600] mx-auto mb-2" />
            <p className="text-gray-500 text-sm">Image coming soon</p>
          </div>
        )}
        <div className="absolute top-3 right-3 bg-[#E10600] text-white text-sm font-bold px-3 py-1 rounded">
          ${product.price}
        </div>
      </div>

      <CardContent className="p-4">
        <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">{product.category}</p>
        <h3 className="text-white font-display text-lg">{product.name}</h3>
        {product.color && <p className="text-gray-400 text-sm mb-3">{product.color}</p>}
        
        {/* Size Selector */}
        <div className="mb-4">
          <p className="text-gray-400 text-xs mb-2">Select Size:</p>
          <div className="flex flex-wrap gap-2">
            {product.sizes.map((size) => (
              <button
                key={size}
                onClick={() => setSelectedSize(size)}
                className={`px-3 py-1 text-sm rounded border transition-all ${
                  selectedSize === size
                    ? "bg-[#E10600] border-[#E10600] text-white"
                    : "border-[#2A2A2A] text-gray-400 hover:border-[#E10600] hover:text-white"
                }`}
                data-testid={`size-${size}`}
              >
                {size}
              </button>
            ))}
          </div>
        </div>

        <Button 
          onClick={handleAddToCart}
          className="w-full bg-[#E10600] hover:bg-[#B80500] text-white"
          data-testid="add-to-cart"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add to Cart
        </Button>
      </CardContent>
    </Card>
  );
};

export default MerchPage;
